var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Progress_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var ProgressObjectType;
(function (ProgressObjectType) {
    ProgressObjectType["UNKNOWN"] = "unknown";
    ProgressObjectType["PIPE"] = "pipe";
    ProgressObjectType["CALCULATION"] = "calculation";
    ProgressObjectType["IMPORT"] = "import";
    ProgressObjectType["IMPORT_ROWCOUNT"] = "import_rowcount";
    ProgressObjectType["UNIT_TEST_DATA_IMPORT"] = "unit_test_data_import";
    ProgressObjectType["UNIT_TEST_DATA_ROWCOUNT"] = "unit_test_data_rowcount";
    ProgressObjectType["UNIT_TEST_SNAPSHOT_IMPORT"] = "unit_test_snapshot_import";
    ProgressObjectType["RUN"] = "run";
    ProgressObjectType["DOWNLOAD"] = "download";
    ProgressObjectType["MATCH"] = "match";
    ProgressObjectType["EXPORT"] = "export";
    ProgressObjectType["LOCK"] = "lock";
    ProgressObjectType["UNIT_TEST"] = "unit_test"; // progress not currently tracked on this object
})(ProgressObjectType || (ProgressObjectType = {}));
const schema = {
    $id: 'urn:wisepipe-compute-activity-domain:Progress',
    type: 'object',
    properties: {
        id: { type: 'string', minLength: 1 }, // Transient calcs are not asscoiated with a pipe, the IDs from those will not match the expected uid definitions
        orgID: { type: 'string', format: 'uuid' },
        objectType: { type: 'string', enum: Object.values(ProgressObjectType) },
        stage: { type: 'string', minLength: 1 },
        expireAt: { type: 'number', minimum: 1 },
        extras: { type: 'object' }
    },
    if: { properties: { objectType: { const: ProgressObjectType.IMPORT_ROWCOUNT } } },
    then: { properties: { progress: { type: 'number', minimum: 0 } } },
    else: { properties: { progress: { type: 'number', minimum: 0, maximum: 1 } } },
    required: ['id', 'orgID', 'objectType', 'progress', 'stage', 'expireAt']
};
let Progress = Progress_1 = class Progress {
    constructor(id, orgID, objectType, progress, stage, expireAt, extras) {
        this.id = id;
        this.orgID = orgID;
        this.objectType = objectType;
        this.progress = progress;
        this.stage = stage;
        this.expireAt = expireAt;
        this.extras = extras;
        JSON.validate(this, Progress_1);
    }
};
Progress = Progress_1 = __decorate([
    JsonSchema(schema)
], Progress);
export { Progress };
//# sourceMappingURL=progress.js.map